import { useNavigate } from 'react-router-dom';
import type { MouseEvent } from '../types';

function NotFound() {
  const navigate = useNavigate();

  function handleGoBack(e: MouseEvent) {
    e.preventDefault();
    void navigate(-1);
  }

  function handleGoHome(e: MouseEvent) {
    e.preventDefault();
    void navigate('/app');
  }

  return (
    <div className="min-h-screen bg-base-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        {/* Error Illustration */}
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto bg-error/10 rounded-full flex items-center justify-center mb-4">
            <i className="fa-solid fa-compass text-4xl text-error"></i>
          </div>
          <div className="space-y-2">
            <h1 className="text-6xl font-bold text-error/20">404</h1>
            <h2 className="text-2xl font-bold text-base-content">Page Not Found</h2>
          </div>
        </div>

        {/* Error Message */}
        <div className="bg-base-200/50 backdrop-blur-sm p-6 rounded-2xl border border-base-300 mb-8">
          <p className="text-base-content/70 leading-relaxed">
            Oops! The page you&apos;re looking for seems to have wandered off the path. Let&apos;s
            get you back on track with your NVC journey.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            className="btn btn-primary w-full h-12 rounded-xl text-base font-medium"
            onClick={handleGoHome}
          >
            <i className="fa-solid fa-home mr-2"></i>
            Back to Lessons
          </button>

          <button
            className="btn btn-outline w-full h-12 rounded-xl text-base font-medium"
            onClick={handleGoBack}
          >
            <i className="fa-solid fa-arrow-left mr-2"></i>
            Go Back
          </button>
        </div>

        {/* Help Text */}
        <div className="mt-8 p-4 bg-base-200/30 rounded-xl">
          <p className="text-xs text-base-content/50">
            If you believe this is an error, please check the URL or contact support.
          </p>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
